/* eslint-disable */
import * as React from "react";

import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

import { ReportToolbarGroup } from "../../../components/ReportToolbar";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexDirection: "column",
      gap: theme.spacing(2),
      "& >*": {
        marginLeft: 0,
      },
    },
  })
);

import { useFavourite } from "./useFavourite";
export default function () {
  const classes = useStyles();

  useFavourite();
  return <ReportToolbarGroup className={classes.root}></ReportToolbarGroup>;
}
